import React from 'react'

const Transaction = () => {
    return (
        <div className="icon-container">
            <svg className="icon-svg" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 3C10.6675 3.62236 8.91707 4 7 4C5.93408 4 4.5 4 2 3V17C4.5 18 5.93408 18 7 18C8.91707 18 10.6675 17.6224 12 17C13.3325 16.3776 15.0829 16 17 16C20 16 22 17 22 17V3C22 3 20 2 17 2C15.0829 2 13.3325 2.37764 12 3Z" stroke="#464858" stroke-width="2" />
                <path d="M2 20C3.33254 20.6224 5.08293 21 7 21C8.91707 21 10.6675 20.6224 12 20C13.3325 19.3776 15.0829 19 17 19C18.9171 19 20.6675 19.3776 22 20" stroke="#464858" stroke-width="2" stroke-linejoin="round" />
                <path d="M14.4512 10C14.4512 11.3807 13.3319 12.5 11.9512 12.5C10.5705 12.5 9.45117 11.3807 9.45117 10C9.45117 8.61929 10.5705 7.5 11.9512 7.5C13.3319 7.5 14.4512 8.61929 14.4512 10Z" stroke="#464858" stroke-width="2" stroke-linejoin="round" />
                <path d="M5.5 11V11.009" stroke="#464858" stroke-width="2" stroke-linecap="square" stroke-linejoin="round" />
                <path d="M18.5 8.99103V9.00001" stroke="#464858" stroke-width="2" stroke-linecap="square" stroke-linejoin="round" />
            </svg>
        </div>
    )
}

export default Transaction